import createClient from './main';

export default createClient;
export {
  createAuthenticator,
  createAuthenticatorCore,
  idCard,
  smartId,
  mobileId,
} from './main';
